import React from "react";
import InstanceManager from "components/app/tool/instanceManager/InstanceManager";

type Props = {};

const ScreenInstanceManager = (props: Props) => {
	return <InstanceManager />;
};

export default ScreenInstanceManager;
